import React from 'react';

import {
  Box,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  activityTemplates,
  AuthWrapper,
  SectionContainer,
  TextSectionWithStepNumber
} from 'modules';

import { PitchDeckTopicSection } from './components/PitchDeckTopicSection/PitchDeckTopicSection';
import * as PitchConstructionSection from './components/PitchConstructionSection/PitchConstructionSection';
import * as PitchDesignSection from './components/PitchDesignSection/PitchDesignSection';
import imgBackground from 'assets/images/background_pitch_deck.png';
import imgCraftYourStoryBackground from 'assets/images/background_pitch_deck_craft_your_story.png';



const CenteredStack = styled(Stack)({
  maxWidth: '860px',
  textAlign: 'center'
});

const FullWidthCenteredBox = styled(Box)({
  width: '100vw',
  display: 'flex',
  justifyContent: 'center'
});

const PitchConstructionBackgroundBox = styled(FullWidthCenteredBox)(({ theme }) => ({
  background: '#0f3749',
  marginTop: -1 // There is a faint white line from the border of the previous child in the image. This blends that
}));

const CraftYourStoryBackgroundBox = styled(FullWidthCenteredBox)({
  backgroundImage: `url(${imgCraftYourStoryBackground})`,
  backgroundColor: '#0f3749',
  backgroundSize: '100%',
  backgroundRepeat: 'no-repeat',
  minHeight: 400
});



export const PitchDecksActivity: React.FC = () => {
  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC
        imgBackground={imgBackground}
        colorVariant="dark"
        backgroundSize="contain"
        doNotWrapChildrenInContainer>
        <SectionContainer.FC
          marginTop="calc(100vw * 0.15 - 112px)"
          marginBottom="calc(100vw * 0.29 - 112px)">
          <CenteredStack spacing={3}>
            <Typography
              variant="h1"
              color="#FFFFFF">
              Pitch Deck Development
            </Typography>

            <Typography
              color="#FFFFFF"
              fontSize={20}>
              Let's get you a compelling pitch deck fast - check out our templates and tips below.
            </Typography>
          </CenteredStack>
        </SectionContainer.FC>

        <SectionContainer.FC marginTop={60}>
          <TextSectionWithStepNumber.FC
            step="1"
            title="Explore Pitch Designs"
            subtitle="Choose from our selection of pitch deck templates and designs to kickstart the fundraise. New slides added monthly!">
          </TextSectionWithStepNumber.FC>
        </SectionContainer.FC>



        <SectionContainer.FC>
          <PitchDesignSection.FC />
        </SectionContainer.FC>



        <CraftYourStoryBackgroundBox>
          <SectionContainer.FC marginTop={210}>
            <Box maxWidth={640}>
              <TextSectionWithStepNumber.FC
                step="2"
                title="Craft Your Story"
                subtitle="Thinking about pitch deck content and messaging? Here's what we are seeing in a typical early and venture-stage pitch deck."
                darkTheme>
              </TextSectionWithStepNumber.FC>
            </Box>

            <Box marginTop={-16}>
              <PitchDeckTopicSection />
            </Box>
          </SectionContainer.FC>
        </CraftYourStoryBackgroundBox>



        <PitchConstructionBackgroundBox>
          <SectionContainer.FC
            marginTop={100}
            marginBottom={80}>
            <PitchConstructionSection.FC />
          </SectionContainer.FC>
        </PitchConstructionBackgroundBox>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
